var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDonateLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 184,
    viewBox: "0 0 173 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.529 92H36.353V178H137.529V92Z",
    stroke: "#F7F7F5",
    strokeWidth: 10.1176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3529 92.0014L6 61.6484",
    stroke: "#F7F7F5",
    strokeWidth: 10.1176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.529 92.0014L167.882 61.6484",
    stroke: "#F7F7F5",
    strokeWidth: 10.1176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.059 36.3516H81.8826L76.8237 41.4104V46.4692L81.8826 51.528H92.0002L97.059 56.5869V61.6457L92.0002 66.7045H76.8237",
    stroke: "#F7F7F5",
    strokeWidth: 10.1176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9414 36.352V26.2344",
    stroke: "#F7F7F5",
    strokeWidth: 10.1176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9414 66.7031V76.8208",
    stroke: "#F7F7F5",
    strokeWidth: 10.1176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9411 119.47C89.4199 114.715 94.6811 111.578 100.6 112.337C107.379 113.197 112.235 119.217 112.235 126.046C112.235 133.382 109.301 140.413 104.141 145.624L86.9411 162.824L69.7411 145.624C64.5305 140.413 61.647 133.382 61.647 126.046C61.647 118.863 67.1105 112.64 74.294 112.236C79.8081 111.932 84.614 114.967 86.9411 119.47Z",
    stroke: "#F7F7F5",
    strokeWidth: 10.1176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0481 92C51.4281 84.4118 41.4116 69.1341 41.4116 51.5294C41.4116 26.3871 61.7987 6 86.941 6C112.083 6 132.47 26.3871 132.47 51.5294C132.47 69.1341 122.454 84.4118 107.834 92",
    stroke: "#F7F7F5",
    strokeWidth: 10.1176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonateLight);
export default __webpack_public_path__ + "static/media/donate_light.b9fcc65a615b42e00ea49849f256554c.svg";
export { ForwardRef as ReactComponent };